<template>
	<div
		class="w-full flex-1 flex flex-col items-center main-content"
		:style="maxHeight ? { maxHeight } : null"
	>
		<slot></slot>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'

	export default {
		name: 'MainContent',
		computed: {
			...mapGetters('system', ['hasToolBar', 'hasInfoBar', 'hasSubtitle']),
			maxHeight() {
				let infoAndToolbarCount = 0
				let subtitleCount = 0

				if (this.hasToolBar) {
					infoAndToolbarCount += 1
				}
				if (this.hasInfoBar) {
					infoAndToolbarCount += 1
				}
				if (this.hasSubtitle) {
					subtitleCount += 1
				}

				return `calc(
					100vh - var(--headerHeight) - (var(--secondaryQuadrantHeight) * 2) -
						(var(--toolAndInfoBarHeight) * ${infoAndToolbarCount}) - (var(--subtitleHeight) * ${subtitleCount}) - (var(--gridGap) * 4)
				)`
			},
		},
	}
</script>

<style></style>
